import Evaluation from "./Evaluation";

export default class User {
    constructor(data) {
      this.id = data.id;
      this.name = data.name;
    }

  /**
   *
   * 評価データの連想配列を読み込む
   * key: type, value: evaluation
   *
   * @param {Object} data
   * @param {number} numStages
   */
  loadEvaluations(data, numStages) {
    if (!data) {
      this.selfEvaluation = new Evaluation(null);
      this.finalEvaluation = new Evaluation(null);
      this.otherEvaluations = {};
      for (let i = 1; i <= numStages; i++) {
        this.otherEvaluations[i] = new Evaluation(null);
      }
      return;
    }

    this.selfEvaluation = new Evaluation(data['SELF']);
    this.finalEvaluation = new Evaluation(data['FINAL']);

    this.otherEvaluations = {};
    for (let i = 1; i <= numStages; i++) {
      const key = `OTHER#${i}`;
      this.otherEvaluations[i] = new Evaluation(data[key]);
    }
  }

  /**
   * 特別評価点を読み込み、プロパティにセットする
   * @param {number|null} val
   */
  loadAdditionalPoint(val) {
    this.additionalPoint = val ? val : 0;
  }

  /**
   * 最終評価がスタートしているか
   *
   * @returns {boolean}
   */
  get isFinalEvaluationStarted() {
    // PENDINGであれば一時的に自己評価や他者評価の編集を許可するので最終評価がスタートしているとみなさない
    if (this.finalEvaluation.status === 'PENDING') {
      return false;
    }
    return this.finalEvaluation.status !== undefined;
  }
}
